import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

export default function MyProfile() {
  const { user } = useAuth();
  if (!user) return null;
  return <Navigate to={`/dashboard/employee/${user.user_id}`} replace />;
}
